import { ChartOptions,Chart as ChartJS } from "chart.js";
import { Bar } from "react-chartjs-2";
import { DomainWidgetProps, BarChartData } from "./dataTypes";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ChartDataLabels);

const DomainWidget = ({ domainResults,module }: DomainWidgetProps) => {


  const generateGraphData = () => {
    if(domainResults) {

      let requiredData: BarChartData = {
        labels: [],
        datasets: [
          {
            label: "Scores in Percentage",
            data: [],
            backgroundColor: ["#2D728F", "#313715", "#E01A4F", "#2CDA9D", "#4A2545", "#EAC435", "#FF4A1C", "#803F7A"],
            borderRadius: 5,
            base: -5
          },
        ],
      };
      domainResults.filter((result) => result.contenttype).forEach((result) => {
        let domainPercentage = parseFloat(
          (
            ((result?.correctquestionscount ?? 0) /
              (result?.totalcontentquestions ?? 1)) *
            100
          ).toFixed(1)
        );
        requiredData.labels.push(result.contenttype ?? "");
        requiredData.datasets[0].data.push(domainPercentage);
      });

      return requiredData;
    }
    return {
      labels: [],
      datasets: [
        {
          label: "Scores in Percentage",
          data: [],
          backgroundColor: "#327AEC",
          borderRadius: 5,
        },
      ],
    };
  }

  const graphData = generateGraphData();

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw}%`;
          },
        },
        titleFont: {
          family: "Gully",
          size: 14,
          weight: "bold",
        },
        bodyFont: {
          family: "Gully",
          size: 12,
        },
        footerFont: {
          family: "Gully",
          size: 12,
          style: "italic",
        },
      },
      datalabels: {
        anchor: "center",
        align: "center",
        color: "#ffffff",
        rotation: -90,
        font: {
          size: 12,
          weight: "bold",
          family: "Gully",
        },
        formatter: (value, context) => {
            const label = context.chart.data.labels?.[context.dataIndex] as string;
            let maxLength = 15;
          
            if (value < 10) {
              return '';
            } else if (value >= 10 && value < 20) {
              maxLength = 4;
            } else if (value >= 20 && value < 30) {
              maxLength = 8;
            } else if (value >= 30 && value < 40) {
              maxLength = 14; 
            } else if (value >= 50 && value < 60) {
              maxLength = 18;
            } else if (value >= 60) {
              maxLength = label.length;
            }
          
            return label.length > maxLength ? `${label.substring(0, maxLength)}...` : label;
          },
          
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Topics",
          color: "#000",
          font: {
            size: 12,
            weight: "bold",
            family: "Gully",
          },
        },
      },
      y: {
        min: -5,
        max: 100,
        beginAtZero: false,
        ticks: {
          font: {
            size: 12,
            weight: "bold",
            family: "Gully",
          },
          stepSize: 10,
          callback: (value) => {
            return value === -5 ? "" : value;
          },
        },
        title: {
          display: true,
          text: "Scores in percentage",
          color: "#000",
          font: {
            size: 14,
            weight: "bold",
            family: "Gully",
          },
        },
      },
    },
  };

  return (
    <div
      className="w-full h-full flex flex-col p-3 gap-3 rounded-[18px] border-[0.5px] border-satPrepGrey bg-satPrepTransWhite backdrop-blur-sevenFive shadow-test-card"
    >
      <p className="text-center font-gully text-xl text-satPrepDarkAccent font-medium">
       Performance by topic
      </p>

      <p className="text-center font-gully text-base text-satPrepXDarkAccent font-normal">
        {module}
      </p>

      <div className="w-full h-full min-h-[300px] flex-grow">
        <Bar data={graphData} options={options} />
      </div>
    </div>
  );
};

export default DomainWidget;
